<template>
  <div class="modal fade" id="mod-action" role="dialog">
    <div class="modal-dialog mx-auto">
      <div class="modal-content p-[24px] bg-[#f8f8f8]">
        <div
          class="modal-header modal-header-colored  flex items-start justify-between p-0 m-0"
        >
          <h4
            class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
          >
            {{ action }} Order
          </h4>
          <button
            class="text-2xl text-[#353535] border-solid border-[#353535] border-[1.5px] rounded-full px-[4px]"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body p-0 m-0">
          <p
            class="text-[#96a0b5] text[14px] font-normal leading-[20px] mt-[8px]"
          >
            You are about to
            <span class="uppercase"
              >{{ action == "delete" ? "withdraw" : action }}
            </span>
            a purchase order with Purchase Order Number {{ purchaseNumber }}
          </p>
        </div>
        <div class="mt-[24px] flex items-center gap-[8px]">
          <button
            class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <div v-if="action == 'submit'" class="w-full">
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="onSubmitClick"
            >
              Submit
            </button>
          </div>
          <div v-else class="w-full">
            <button
              class="bg-[#DC2828] border-[#DC2828] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="onSubmitClick"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionStatusModal",
  props: ["action", "purchaseNumber"],
  methods: {
    onSubmitClick() {
      switch (this.action) {
        case "submit":
          this.$emit("onSubmit");
          break;
        case "withdraw":
          this.$emit("onWithdraw");
          break;
        case "delete":
          this.$emit("onDelete");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style></style>
